import React, { ReactNode } from 'react';
import { usePageTransition, TransitionType } from '../../Hooks/usePageTransition';

interface ComponentTransitionProps {
  children: ReactNode;
  transitionType?: TransitionType;
  delay?: number;
  className?: string;
  style?: React.CSSProperties;
}

const ComponentTransition: React.FC<ComponentTransitionProps> = ({
  children,
  transitionType = 'fade',
  delay = 50,
  className = '',
  style = {}
}) => {
  const { getTransitionClasses } = usePageTransition({
    delay,
    transitionType
  });

  return (
    <div 
      className={`${getTransitionClasses()} ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default ComponentTransition;